export default __webpack_public_path__ + "static/media/adding_prospects_step3.3e766ac3.png";